// extracted by mini-css-extract-plugin
module.exports = {"group_notes":"group_notes--2p4Uh","group_notes_links":"group_notes_links--RT7mH","group_notes_link":"group_notes_link--19qJD","group_notes_share":"group_notes_share--3qZs0"};